<template>
<section class="container">
    <div class="con_title">
      <img class="con_title_icon" src="../../assets/images/evaluate/success.png">
      <img class="con_title_icon" src="../../assets/images/evaluate/icon_warning_secondary.png">
      <p class="con_title_t">开闸成功</p>
    </div>
    <p class="con_time_title">本次自助进出随机码为</p>
</section>
</template>

<script>
import {mapState} from 'vuex';
export default {
  name: 'kaizhaStatus',
  props: {},
  components: {

  },
  filters: {
  },
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  data() {
    return {
    }
  },
  created(){
  },
  methods:{}
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";
.con_title {
    margin-top: 80px;
    display: flex;
    align-items: center;
    flex-direction:column;
    .con_title_icon {
      width:116px;
      height:116px;
      margin-bottom:28px;
    }
    .con_title_t {
      font-size: 44px;
      color: rgba(51,51,51,1);
      line-height: 60px;
      margin-bottom:20px;
    }
}
.con_time_title{
  height:42px;
  font-size:30px;
  color:rgba(102,102,102,1);
  line-height:42px;
  margin-bottom:40px;
  text-align:center;
}
</style>
